/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { JobsListOptions } from './jobs-list.interface';

@Component({
  selector: 'jobs-list',
  templateUrl: './jobs-list.component.html',
  styleUrls: ['./jobs-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobsListComponent implements OnInit {
  @Input() options: JobsListOptions;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  jobs: any[] = [];
  totalJobs: number = 0;
  totalPages: number;
  isLazyLoading: boolean = false;
  paramObj: any;

  constructor(
    private localisationService: LocalisationService,
    private dataCollectorService: DataCollectorService,
    private utilityService: UtilityService) {

  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.getJobs();
  }

  getJobs(): void {
    if (this.options?.url && this.options?.paramObj) {
      this.paramObj = this.options.paramObj;
      this.dataCollectorService.getData(this.options?.url, this.paramObj)
        .subscribe(
          (jobs: any) => {
            this.jobs = jobs.data;
            this.totalJobs = jobs.total_records;
            this.totalPages = jobs.total_pages;
            this.eventEmitter?.emit({ jobsCount: this.totalJobs });
          }, (error: any) => {
            this.eventEmitter?.emit({ jobsCount: this.totalJobs });
          });
    }
  }

  showLazyLoading(isLoading: boolean): void {
    this.isLazyLoading = isLoading;
  }

  lazyLoadingEmit(event: any): void {
    if (event?.fetchedData) {
      this.jobs = this.jobs.concat(event?.fetchedData);
    }
  }

  getJobsStatus(jobStatus: any[]): any {
    return jobStatus[jobStatus.length - 1];
  }

  getstyles(jobsStatus: any[]): any {
    let styles: any = {};
    const jobStatus: any = this.getJobsStatus(jobsStatus);
    if (jobStatus && jobStatus['status_color']) {
      styles = {
        'fill': jobStatus['status_color']
      };
    }
    return styles;
  }

  getJobStatusClass(jobsStatus: any[]): any {
    const statusClass: any = {};
    const jobStatus: any = this.getJobsStatus(jobsStatus);
    statusClass['job-status-' + jobStatus['status_type']] = !jobStatus['status_color'];
    return statusClass;
  }
}
